import { formatTriggerSelectLabel } from '~/app/components/maintenance/tasks-triggers/utils';
import type { AssetDisplayInfo } from './types';

export function formatDate(value: Date | string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
}

/** Primary asset label: name, optionally with serial (e.g. "ABB Terra — #CH-1123"). */
export function formatAssetLabel(
  name: string | null | undefined,
  serialNumber?: string | null,
  fallbackId?: string,
): string {
  const displayName = name?.trim() || fallbackId || '—';
  const serial = serialNumber?.trim();
  if (!serial) {
    return displayName;
  }
  return `${displayName} — #${serial}`;
}

export function formatTriggerLabel(
  basis: string | undefined,
  conditions:
    | ReadonlyArray<{
        conditionType: string;
        intervalValue: number;
        intervalUnit: string;
      }>
    | undefined,
  fallbackId?: string,
): string {
  if (!basis) {
    return fallbackId ?? '—';
  }
  return formatTriggerSelectLabel(basis, conditions ?? []);
}

export function resolveAssetDisplay(
  map: Map<string, AssetDisplayInfo>,
  assetId: string,
): AssetDisplayInfo {
  return (
    map.get(assetId) ?? {
      name: assetId,
      serialNumber: null,
      siteName: null,
    }
  );
}
